import { useQuery } from "react-query";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import { getCurrentUser } from "@src/auth/getCurrentUser";
import { TRawUserRights } from "@propely/propely-typings";

export const useUserRightsKey = (userID: string) => ["userRights", { userID }];

export const useUserRights = () => {
  const { userId } = getCurrentUser();
  const $userRights = useQuery(useUserRightsKey(userId), async () => {
    const userRights = await getDoc(doc(getFirestore(), "userRights", userId));
    return TRawUserRights.parse({
      id: userRights.id,
      ...userRights.data(),
    });
  });
  return {
    $userRights,
    userRights: $userRights.data,
  };
};
